import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import StatusBadge from "@/components/app/StatusBadge";

const SOURCES = ["suntronix", "hrms", "mdm", "erp", "courier", "abm", "intune", "entra", "jamf", "manual"];

export default function SourcePriority() {
  const [rules, setRules] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => { api.get("/reconciliation/source-priority").then(({ data }) => setRules(data.items || [])); };
  useEffect(load, []);

  const save = async (field, source) => {
    setBusy(true);
    try {
      await api.post("/reconciliation/source-priority", { field, authoritative_source: source });
      toast.success("Source priority saved");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-[1200px]">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.08em] uppercase text-slate-500">Asset Intelligence</div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">Reconciliation — Source Priority</h1>
        <p className="text-sm text-slate-500 mt-0.5">Choose which connected system is authoritative when values disagree. Every change is logged.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-[10px] uppercase tracking-widest">
            <tr>
              <th className="px-3 py-2 text-left">Field</th>
              <th className="px-3 py-2 text-left">Authoritative source</th>
              <th className="px-3 py-2 text-left">Update</th>
            </tr>
          </thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.field} className="border-t border-slate-100">
                <td className="px-3 py-2">
                  <div className="font-medium text-slate-800">{r.label || r.field}</div>
                  <div className="text-[10px] font-mono text-slate-400">{r.field}</div>
                </td>
                <td className="px-3 py-2"><StatusBadge value={r.authoritative_source} /></td>
                <td className="px-3 py-2">
                  <div className="flex items-center gap-2">
                    <Select onValueChange={(v) => save(r.field, v)} disabled={busy}>
                      <SelectTrigger className="h-8 w-40"><SelectValue placeholder="Choose source" /></SelectTrigger>
                      <SelectContent>{SOURCES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                    </Select>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
